var map = {
	"./glosaio-1.png": "a27e",
	"./glosaio-10.png": "b07c",
	"./glosaio-11.png": "4ea2",
	"./glosaio-2.png": "7d5f",
	"./glosaio-3.png": "628d",
	"./glosaio-4.png": "f8b7",
	"./glosaio-5.png": "4232",
	"./glosaio-6.png": "f13b",
	"./glosaio-7.png": "d9ae",
	"./glosaio-8.png": "92a9",
	"./glosaio-9.png": "edcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "023b";